<template>
  <section :class="['hero is-fullheight is-bold', color]">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">{{ question.question }}</h1>

        <div class="field is-grouped">
          <p class="control">
            <button class="button" @click.prevent="active=true">
              {{ question.yes }}
            </button>
          </p>
          <p class="control" @mouseenter="sayNo" :style="style" id="not">
            <button class="button">
              {{ question.not }}
            </button>
          </p>
        </div>
      </div>
    </div>
    <div class="hero-foot">
      <nav class="tabs is-boxed is-fullwidth">
        <div class="container">
          <ul>
            <li>
              <router-link :to="{name: 'Home'}">
                Crear nueva pregunta
              </router-link>
            </li>
            <li><a id="copyLink" :data-clipboard-text="fullPage">Copiar link</a></li>
          </ul>
        </div>
      </nav>
    </div>

    <div id="modal" :class="['modal', {'is-active': active}]">
      <div class="modal-background" @click.prevent="active=false"></div>
      <div class="modal-content">
        <article :class="['notification is-light']">
          {{ question.confirm }}
          <router-link :to="{name: 'Home'}" class="is-block has-text-link-dark mt-5 is-size-7">
            Crear nueva pregunta
          </router-link>
        </article>
      </div>
      <button class="modal-close is-large" aria-label="close" @click.prevent="active=false">
      </button>
    </div>
  </section>
</template>

<script>

import Vue from 'vue';
import Clipboard from 'clipboard';
import firebase from '../firebaseConfig';

export default {
  data() {
    return {
      style: {
        position: 'relative',
        top: 0,
        left: 0,
      },
      color: 'is-primary',
      active: false,
      question: {
        confirm: '',
        not: '',
        question: '',
        yes: '',
        date: '',
      },
      fullPage: '',
    };
  },

  beforeRouteEnter(to, from, next) {
    const question = Vue.localStorage.get(to.params.id, null);

    if (question) {
      next((vm) => vm.setData(JSON.parse(question)));
    } else {
      firebase
        .firestore()
        .collection('questions')
        .doc(to.params.id)
        .get()
        .then((document) => {
          Vue.localStorage.set(to.params.id, JSON.stringify(document.data()));

          next((vm) => vm.setData(document.data()));
        });
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.question = {
      confirm: '',
      not: '',
      question: '',
      yes: '',
      date: '',
    };

    const question = Vue.localStorage.get(to.params.id, null);

    if (question) {
      this.setData(JSON.parse(question));
      next();
    } else {
      firebase
        .firestore()
        .collection('questions')
        .doc(to.params.id)
        .get()
        .then((document) => {
          this.$localStorage.set(to.params.id, JSON.stringify(document.data()));
          this.setData(document.data());
          next();
        });
    }
  },

  created() {
    const colors = [
      'is-primary',
      'is-info',
      'is-success',
      'is-link',
      'is-warning',
      'is-danger',
      'is-light',
      'is-dark',
    ];

    this.color = colors[Math.floor(Math.random() * colors.length)];
  },

  mounted() {
    const clipboard = new Clipboard('#copyLink');
    clipboard.on('success', (e) => {
      this.$toastr.s({
        title: 'El link ha sido copiado',
        msg: e.text,
      });
    });
  },

  methods: {
    sayNo() {
      const position = this.position();

      this.style.top = `${position.y}px`;
      this.style.left = `${position.x}px`;
      this.style.position = 'fixed';
    },

    position() {
      const width = document.getElementById('not').offsetWidth;
      const height = document.getElementById('not').offsetHeight;

      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

      const x = (Math.random() * (vw - width)).toFixed();
      const y = (Math.random() * (vh - height)).toFixed();

      return { x, y };
    },

    setData(data) {
      if (!data) {
        this.$router.push({
          name: 'Home',
        });
      }

      this.question = data;
      this.fullPage = window.location.href;
    },
  },
};
</script>
